export const storage = localStorage;

export function getItem(key) {
  const item = storage.getItem(key);
  try {
    return item ? JSON.parse(item) : undefined;
  } catch (err) {
    return undefined;
  }
}

export function setItem(key, object) {
  try {
    storage.setItem(key, JSON.stringify(object));
  } catch (err) {
    storage.setItem(key, null);
  }
}

export const APPLICATION_KEY = '__APPLICATION_KEY';

export const resetStorage = () => {
  setItem(APPLICATION_KEY, {});
  window.location.reload();
};
